import api from 'utils/api'

export const resetPassword = data => {
  return api.post('/auth/reset_password/', data)
}

export const checkToken = token => {
  return api.get('/auth/reset_password_token_enquiry/', { token })
}
